import WorldIcon from 'components/ReusableComponents/Icons/World'
import useCopyText from 'hooks/useCopyText'
import usePipedriveOrganization from 'hooks/usePipedriveOrganization'
import { useInternalAdmin } from 'hooks'
import { useSelector } from 'react-redux'

import { selectCurrentHotelId } from '../../../accessors'
import { ReactComponent as PipedriveIcon } from './pipedrive.svg'

const HeaderChecklist = () => {
  const copy = useCopyText()
  const currentHotelId = useSelector(selectCurrentHotelId)
  const isGdsBookingAvailable = useSelector(s => s.hotelDetails.isGdsBookingAvailable)
  const displayId = useSelector(s => s.hotelDetails.displayId)
  const isInternalAdmin = useInternalAdmin()
  const {
    isLoading: isPipedriveLoading,
    error: pipedriveError,
    openOrganization: openPipedriveOrganization
  } = usePipedriveOrganization(displayId)
  const isPipedriveReady = Boolean(displayId) && !isPipedriveLoading && !pipedriveError

  return (
    <>
      <span
        role="button"
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            if (currentHotelId) copy(currentHotelId)
          }
        }}
        onDoubleClick={e => {
          e.stopPropagation()
          if (currentHotelId) copy(currentHotelId)
        }}
        style={{ cursor: 'pointer', display: 'inline-flex' }}
        title="GDS Booking is available. Double-click to copy hotel ID"
      >
        <WorldIcon
          fill={isGdsBookingAvailable ? '#66bb6a' : '#b7babf'}
          width="27px"
          height="27px"
          style={{ position: 'releative', top: '0', marginRight: 6 }}
        />
      </span>
      {isInternalAdmin && (
        <button
          type="button"
          onClick={openPipedriveOrganization}
          disabled={!displayId || isPipedriveLoading}
          aria-label="Open Pipedrive organization"
          title={pipedriveError || 'Open Pipedrive organization'}
          style={{
            height: 27,
            padding: 0,
            border: 'none',
            background: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            cursor: displayId ? 'pointer' : 'default'
          }}
        >
          <PipedriveIcon
            width="27px"
            height="27px"
            style={{
              position: 'releative',
              top: '0',
              marginRight: 12,
              ...(isPipedriveReady ? null : { filter: 'grayscale(100%)', opacity: 0.7 })
            }}
          />
        </button>
      )}
    </>
  )
}

export default HeaderChecklist
